import { ActivityKeys } from "web_myplann/Api/Activities/ActivityKeys";
import { limit } from "web_myplann/Api/infiniteQueryUtils";
import { useListInfiniteQuery } from "web_myplann/Api/useListInfiniteQuery";
import { getDashboardEventsV2 } from "web_myplann/Infrastructure/Api/Api";

export const useEventsInfiniteQuery = (
	filterDatefrom?: string,
	filterDateto?: string,
	filterOnlyunsolved?: boolean,
	filterOnlysolved?: boolean,
	filterSortdesc?: boolean,
	pageSize: number = limit,
	options?: { enabled?: boolean },
) =>
	useListInfiniteQuery(
		ActivityKeys.infiniteEvents(
			filterDatefrom,
			filterDateto,
			filterOnlyunsolved,
			filterOnlysolved,
			filterSortdesc,
			pageSize,
		),
		(offset) =>
			getDashboardEventsV2(
				filterDatefrom,
				filterDateto,
				filterOnlyunsolved,
				filterOnlysolved,
				pageSize,
				offset,
				filterSortdesc,
			),
		{ pageSize, enabled: options?.enabled !== false },
	);
